import { useCallback } from 'react';
import { di } from 'react-magnetic-di';

import type { AsyncFieldConfiguration } from '@atlassian/proforma-form-renderer/async-fields';

import { useAffectedServicesService } from '../../../../../services/affected-services';

export const useAffectedServices = () => {
	di(useAffectedServicesService);
	const { fetch } = useAffectedServicesService();

	return useCallback(
		(): AsyncFieldConfiguration => ({
			loadOptions: async (query) => {
				const data = await fetch(query);
				return data.services.map((affectedService) => ({
					value: affectedService.id,
					label: affectedService.name,
				}));
			},
			defaultOptions: true,
		}),
		[fetch],
	);
};
